import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { PricesService } from "../../_services/prices.service";

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-edit-price',
  templateUrl: './edit-price.component.html',
  styleUrls: ['./edit-price.component.css']
})
export class EditPriceComponent implements OnInit {

  editPriceForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  original_price: any;
  commission_price: any;
  docid: any;

  id = this.route.snapshot.params.id;


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }


    this.editPriceForm = this.formBuilder.group({
      mental_health_type: [{value: '', disabled: true}, [Validators.required]],
      experience: [{value: '', disabled: true}, [Validators.required]],
      price_for: ['', [Validators.required]],
      doctor_price: ['', [Validators.required]],
      percent: ['', [Validators.required,Validators.max(100), Validators.min(0)]],
      status: ['true', [Validators.required]],
    });



    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    const payload = {
      id: this.id
    };

    this.getPriceById(payload);

  }

  get f() { return this.editPriceForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.editPriceForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      type: 'theripist',
      mental_health_type: this.editPriceForm.controls.mental_health_type.value,
      experience: this.editPriceForm.controls.experience.value,
      docid: this.docid,
      price_for: this.editPriceForm.controls.price_for.value,
      original_price: this.original_price,
      percent: this.editPriceForm.controls.percent.value,
      doctor_price: this.editPriceForm.controls.doctor_price.value,
      commission_price: this.commission_price,
      status: this.editPriceForm.controls.status.value,
      id: this.id
    };


    this.editPrice(addPayload);

  }

  onChange(){
    let doctor_price = (this.editPriceForm.controls.doctor_price.value)?Number(this.editPriceForm.controls.doctor_price.value):0;
    let percentage = (this.editPriceForm.controls.percent.value)?Number(this.editPriceForm.controls.percent.value):0;

    this.original_price = (doctor_price + (percentage/100*doctor_price));

    this.commission_price = (this.original_price - doctor_price);

  }


  editPrice(payload) {
    this.pricesService.editPrice(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate([`/get-prices/${this.docid}`]);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add Price', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add Price', error);
        });
  }

  getPriceById(payload) {
    this.pricesService.getPriceById(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.editPriceForm.setValue({
              mental_health_type: data.priceList.mental_health_type,
              experience: data.priceList.experience,
              price_for: (data.priceList.price_for)?data.priceList.price_for:'',
              doctor_price: data.priceList.doctor_price,
              percent: data.priceList.percent,
              status: (data.priceList.status == true)?'true':'false',
            });
            this.original_price = data.priceList.original_price;
            this.commission_price = data.priceList.commission_price;
            this.docid = (data.priceList.docid)?data.priceList.docid:'';


          } else {

            this.toaster.showError('Add Price', data.ResponseMessage);
          }
        },
        error => {

          this.toaster.showError('Add Price', error);
        });
  }
}
